module.exports = __webpack_public_path__ + "img/automation-pause.655e730a.svg";